import React from "react";
import { Label, Input } from "reactstrap";

const RegisterAgreements = ({
  fhpPolicy, setFhpPolicy,
  terms, setTerms,
  setTac,
  identity, setIdentity,
  copyItems, setCopyItems,
}) => {
  return (
    <>
      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          className="custom-checkbox"
          checked={fhpPolicy}
          onChange={(e) => setFhpPolicy(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I agree not pay more than $599 for any individual NIL good or CHat at FHP.
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          className="custom-checkbox"
          checked={terms}
          onChange={(e) => setTerms(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          Accept terms & conditions.{" "}
          <span
            onClick={() => setTac(true)}
            style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
          >
            View
          </span>
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          className="custom-checkbox"
          checked={identity}
          onChange={(e) => setIdentity(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand that FansHelpPlayers.com does not verify or guarantee the
          identity of any of the people registered on site. I acknowledge that I
          take full and sole responsibility regarding assessing that an athlete
          featured in a profile is truly the individual athlete himself or herself.
        </Label>
      </div>

      <div className="d-flex mt-4 ml-4">
        <Input
          required
          type="checkbox"
          className="custom-checkbox"
          checked={copyItems}
          onChange={(e) => setCopyItems(e.target.checked)}
        />
        <Label className="custom-checkbox-label text-dark mx-4 mt-1">
          I understand that when I buy a copy of a digital item on the FHP
          platform, the athlete prefers that I not make a copy of said item, such
          as to sell to a third party. I further understand and support that a
          goal of FansHelpPlayers (FHP) is to assist the student athletes to earn
          NIL money. I agree to honor the wishes of the athlete.
        </Label>
      </div>
    </>
  );
};

export default RegisterAgreements;
